import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="customerRecords";

export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}
export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}

export function queryByMansionId(parameter,mansionId) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/queryByMansionId/${mansionId}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export default {
  insert,
  update,
  queryByMansionId
}